import React from 'react';
import { colors, Grid, makeStyles } from '@material-ui/core';
import { Redirect } from 'react-router-dom';

import APP_NAME from 'config/app_name';
import Routes, { CreateAccountPageSteps } from 'config/routes';
import { SignUpFormFields } from 'config/sign_up_form';

import Description from 'components/typography/Description';
import Step from 'components/stepper/Step';
import SingleFormPage from 'components/form/SingleFormPage';

import RequestStep from './request/RequestStep';
import mapStepToInput from './mapStepToInput';
import mapStepToDescription from './mapStepToDescription';

const useStyles = makeStyles({
  appName: {
    color: colors.red[400],
    fontFamily: 'Pacifico,cursive',
  },
});

const CreateAccountSteps = ({
  step,
  backRouter,
  nextRouter,
  form,
  setForm,
  formValidator,
  exitPage,
}) => {
  const classes = useStyles();

  if (!Object.keys(CreateAccountPageSteps).includes(step))
    return (
      <Redirect to={Routes.createAccount(SignUpFormFields.first)}></Redirect>
    );

  return (
    <Grid container direction="column" spacing={5}>
      <Grid item container justify="center">
        <Description variant="h6">
          Join <span className={classes.appName}>{APP_NAME}</span>
        </Description>
      </Grid>

      <Grid item container>
        <Step
          step={step}
          onBackButtonClick={() => backRouter(step)}
          stepTitle="Create account"
          fullWidthBody={true}
          headerStyle={{ marginLeft: -16 }}
          renderBody={() => {
            if (Object.keys(SignUpFormFields).includes(step))
              return (
                <SingleFormPage
                  key={step}
                  Input={mapStepToInput(step)}
                  onInputSubmit={() => nextRouter(step)}
                  validator={formValidator[step]}
                  inputValue={form[step]}
                  onInputChange={(value) => setForm({ ...form, [step]: value })}
                  submitButtonLabel={
                    step === SignUpFormFields.passwordConfirmation
                      ? 'CREATE ACCOUNT'
                      : 'NEXT STEP'
                  }
                ></SingleFormPage>
              );

            return (
              <RequestStep signUpForm={form} exitPage={exitPage}></RequestStep>
            );
          }}
          renderDescription={() => {
            const Description = mapStepToDescription(step);
            return <Description></Description>;
          }}
        ></Step>
      </Grid>
    </Grid>
  );
};

export default CreateAccountSteps;
